import { render, staticRenderFns } from "./DocumentSeriesAllocationListFilter.vue?vue&type=template&id=2836c9e8&scoped=true&"
import script from "./DocumentSeriesAllocationListFilter.vue?vue&type=script&lang=js&"
export * from "./DocumentSeriesAllocationListFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2836c9e8",
  null
  
)

export default component.exports